import {
  SAVE_USER,
  SAVE_USER_PROFILE,
  SAVE_USER_NOTIFICATION_SETTINGS,
  SAVE_USER_ACCOUNTS,
} from 'redux/constants/User';

export function saveUser(user) {
  return {
    type: SAVE_USER,
    payload: user
  };
}

export function saveUserProfile(userProfile) {
  return {
    type: SAVE_USER_PROFILE,
    payload: userProfile
  };
} 

export function saveUserNotificationSettings(userNotificationSettings) {
  return {
    type: SAVE_USER_NOTIFICATION_SETTINGS,
    payload: userNotificationSettings
  };
}

export function saveUserAccounts(userAccounts) {
  return {
    type: SAVE_USER_ACCOUNTS,
    payload: userAccounts
  };
}
